import { Table } from '@/components/custom_field/table'

export const CustomFields = () => {
  return (
    <>
      <Table pageSize={20} createable onIndex />
    </>
  )
}
